var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F4F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E0D7FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#a)",
    stroke: "#6030FF",
    strokeWidth: 1.895,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6030FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.412 7.778l.01 5.868a17.61 17.61 0 0 0 .82.02c.953 0 1.676-.254 2.169-.76.492-.505.739-1.248.739-2.228 0-.91-.215-1.62-.644-2.132-.429-.512-1.022-.768-1.778-.768h-1.316zM9 7.024h4.119c1.29 0 2.28.313 2.97.94.69.626 1.034 1.531 1.034 2.714 0 1.145-.397 2.06-1.191 2.744-.795.684-1.87 1.026-3.223 1.026a15.957 15.957 0 0 1-1.297-.038v2.595c0 .649.059 1.175.177 1.58.117.403.3.815.548 1.235H9a5.32 5.32 0 0 0 .53-1.236c.11-.404.166-.93.166-1.579V9.829c0-.649-.056-1.174-.167-1.574A5.348 5.348 0 0 0 9 7.024zM16 6h2.03v2.047"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c1d5d0666e47c4b0100a904bfff18c0b.svg";
export { ForwardRef as ReactComponent };